"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hangChange = exports.getActivityListByProDefId = exports.flowNodeSave = exports.deleteProcessByDeploymentId = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 根据流程定义id 操作挂起激活 true 挂起， false 未挂起
 * @param procDefId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var hangChange = exports.hangChange = function hangChange(procDefId) {
  return _api.default.request({
    url: '/flow/process/hangChange',
    method: 'post',
    params: {
      processDefinitionId: procDefId
    }
  });
};

/**
 * 删除流程定义
 * @param deploymentId
 * @returns {AxiosPromise}
 */
var deleteProcessByDeploymentId = exports.deleteProcessByDeploymentId = function deleteProcessByDeploymentId(deploymentId) {
  return _api.default.request({
    url: '/flow/process/delete',
    method: 'post',
    params: {
      deploymentId: deploymentId
    }
  });
};
var flowNodeSave = exports.flowNodeSave = function flowNodeSave(flowNodeUpdateInputDTOs) {
  return _api.default.request({
    url: '/flow/flow-node/save',
    method: 'post',
    data: flowNodeUpdateInputDTOs
  });
};
var getActivityListByProDefId = exports.getActivityListByProDefId = function getActivityListByProDefId(processDefinitionId) {
  return _api.default.request({
    url: '/flow/flow-node/getActivityListByProDefId',
    params: {
      processDefinitionId: processDefinitionId
    }
  });
};